import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PDFViewer, pdf } from "@react-pdf/renderer";
import PurInvoiceData from '../data/PurInvoiceData';
import InvoiceDocument from '../components/PurInvoiceDocumentFormat/PurInvoiceDocument';
import { Box, CircularProgress, Typography, Button, Tooltip, Menu, MenuItem, ListItemIcon, } from "@mui/material";
import axios from 'axios';
import { Email, WhatsApp } from "@mui/icons-material";
import ShareIcon from "@mui/icons-material/Share";

const PurInvoiceViewPage = ({ loggedInUser, companyData, connectionString }) => {
    const path = connectionString;
    const { saleInvoiceId } = useParams();
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    console.log("companyId: ", companyData);
    const companyId = companyData?.[0]?.CompId;
    const company = Array.isArray(companyData) ? companyData[0] : companyData;

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await PurInvoiceData(saleInvoiceId, connectionString, companyId);
                setInvoice(data);
            } catch (err) {
                setError("Failed to load challan.");
            } finally {
                setLoading(false);
            }
        };
        fetch();
    }, [saleInvoiceId]);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    // ? Unified share/download logic
    const sharePDF = async (invoice, target = "whatsapp") => {
        try {
            const blob = await pdf(<InvoiceDocument invoice={invoice} loggedInUser={loggedInUser} companyData={companyData} connectionString={connectionString} />).toBlob();

            // ? Filename: QuotationNo_FirmName.pdf
            const safeFirmName = invoice.companyName.replace(/[^a-z0-9]/gi, "_");
            const fileName = `${invoice.invoiceNo}_${safeFirmName}.pdf`;

            const file = new File([blob], fileName, { type: "application/pdf" });

            // 1?? If sharing to WhatsApp and navigator.share is supported ? Direct Share
            if (target === "whatsapp" && navigator.canShare && navigator.canShare({ files: [file] })) {
                await navigator.share({
                    title: `Challan ${invoice.invoiceNo}`,
                    text: `Please check the attached quotation for ${invoice.companyName}`,
                    files: [file],
                });
                return;
            }

            // 2?? If File System Access API available ? Save As dialog
            if (window.showSaveFilePicker) {
                const handle = await window.showSaveFilePicker({
                    suggestedName: fileName,
                    types: [{ description: "PDF Document", accept: { "application/pdf": [".pdf"] } }],
                });
                const writable = await handle.createWritable();
                await writable.write(blob);
                await writable.close();
                alert(`? Saved locally as ${fileName}`);
                return;
            }

            const formData = new FormData();

            // 3) POST the form data to the backend
            const response = await axios.post(`${path}/api/send-invoice`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });

            console.log('[sendChallanToBackend] Upload success:', response.data);
            alert('Quota sent to backend!');

            // 3?? Fallback ? force browser download
            const url = URL.createObjectURL(file);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);

            if (target === "whatsapp") {
                alert(`?? PDF downloaded as ${fileName}.\nAttach it manually in WhatsApp chat.`);
            } else if (target === "email") {
                window.location.href = `mailto:${invoice.toEmail}?subject=Quotation ${invoice.invoiceNo}&body=Please find attached quotation PDF.`;
            }
        } catch (err) {
            console.error("Share failed:", err);
            alert("Failed to share PDF.");
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={4}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ position: "relative", width: "100%", height: "100vh" }}>
            <Tooltip title="Share" arrow>
                <Button
                    onClick={handleClick}
                    sx={{
                        position: "fixed",
                        top: 18,
                        right: 165,
                        zIndex: 10,
                        minWidth: 38,
                        height: 38,
                        borderRadius: "50%",
                        "&:hover": {
                            bgcolor: "grey.700",
                            boxShadow: "0 0 12px 3px white",
                        },
                    }}
                >
                    <ShareIcon sx={{ fontSize: 22, color: "white" }} />
                </Button>
            </Tooltip>

            {/* Dropdown Menu */}
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem
                    onClick={() => {
                        handleClose();
                        sharePDF(invoice, "whatsapp");
                    }}
                    sx={{ "&:hover": { bgcolor: "rgba(37, 211, 102, 0.1)" } }}
                >
                    <ListItemIcon>
                        <WhatsApp sx={{ color: "#25D366" }} />
                    </ListItemIcon>
                    WhatsApp
                </MenuItem>

                <MenuItem
                    onClick={() => {
                        handleClose();
                        sharePDF(invoice, "email");
                    }}
                    sx={{ "&:hover": { bgcolor: "rgba(234, 67, 53, 0.1)" } }}
                >
                    <ListItemIcon>
                        <Email sx={{ color: "#EA4335" }} />
                    </ListItemIcon>
                    Email
                </MenuItem>
            </Menu>

            {/* PDF Viewer */}
            <Box sx={{ width: "100%", height: "100%" }}>
                <PDFViewer width="100%" height="100%">
                    <InvoiceDocument invoice={invoice} loggedInUser={loggedInUser} companyData={company} connectionString={connectionString} />
                </PDFViewer>
            </Box>
        </Box>
    );
};

export default PurInvoiceViewPage;






// import { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { PDFViewer } from '@react-pdf/renderer';
// import PurInvoiceData from '../data/PurInvoiceData';
// import InvoiceDocument from '../components/PurInvoiceDocumentFormat/PurInvoiceDocument';
// import { Box, CircularProgress, Typography, Button } from '@mui/material';
// import { pdf } from '@react-pdf/renderer';
// import axios from 'axios';


// const PurInvoiceViewPage = ({ companyData, connectionString }) => {

//     const path = connectionString;
    
//     const { saleInvoiceId } = useParams();
//     const [invoice, setInvoice] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState();

//     useEffect(() => {
//         const fetch = async () => {
//             try {
//                 console.log('[InvoiceViewPage] Fetching invoice data…', saleInvoiceId);
//                 const data = await PurInvoiceData(saleInvoiceId, connectionString);
//                 console.log('[InvoiceViewPage] Fetched invoice:', data);
//                 setInvoice(data);
//             } catch (err) {
//                 console.error('[InvoiceViewPage] Error:', err);
//                 setError('Failed to load invoice.');
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetch();
//     }, [saleInvoiceId]);

//     // 🧠 Function to send invoice to backend
//     const sendInvoiceToBackend = async (invoice) => {
//         try {
//             // 1) Generate the PDF blob
//             const blob = await pdf(<InvoiceDocument invoice={invoice} companyData={companyData} />).toBlob();

//             // 2) Prepare form data
//             const fileName = `${invoice.invoiceNo}_${invoice.companyName}.pdf`;
//             const formData = new FormData();
//             formData.append('pdf', blob, fileName);
//             formData.append('companyName', invoice.companyName);
//             formData.append('invoiceNo', invoice.invoiceNo);
//             formData.append('mobileNo', invoice.mobileNo)

//             // now this will be defined
//             formData.append('toEmail', invoice.toEmail);

//             // 🔍 Debug: log every key/value
//             for (let [key, val] of formData.entries()) {
//                 console.log(`FormData ${key}:`, val);
//             }

//             // 3) Send to backend
//             const response = await axios.post(`${path}/api/send-invoice`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });

//             console.log('Upload success:', response.data);
//             alert('Invoice sent to backend!');
//         } catch (error) {
//             console.error('Error sending invoice:', error);
//             alert('Failed to send invoice.');
//         }
//     };

//     if (loading) {
//         return (
//             <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
//                 <CircularProgress />
//             </Box>
//         );
//     }

//     if (error) {
//         return (
//             <Box p={4}>
//                 <Typography color="error">{error}</Typography>
//             </Box>
//         );
//     }

//     return (
//         <Box sx={{ position: 'relative', width: '100%', height: '100vh' }}>
//             {/* Fixed Send to User Button */}
//             <Button variant="contained" color="primary" onClick={() => sendInvoiceToBackend(invoice)} sx={{ position: 'fixed', top: 10, right: 16, zIndex: 10, }} >
//                 Send to User
//             </Button>
//             {/* Full Page PDF Viewer */}
//             <Box sx={{ width: '100%', height: '100%' }}>
//                 <PDFViewer width="100%" height="100%">
//                     <InvoiceDocument invoice={invoice} companyData={companyData} />
//                 </PDFViewer>
//             </Box>
//         </Box>
//     );
// };

// export default PurInvoiceViewPage;